import { Box, Button, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ModalWrapper } from 'src/components'

import { useStyles } from './styles'

interface IProps {
  open: boolean
  handleClose: () => void
  traicyRejectReason: string
}

export const MediaValidationModal = ({ open, handleClose, traicyRejectReason }: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()
  const theme = useTheme()

  return (
    <ModalWrapper open={open} onClose={handleClose} className={classes.verifyModal}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',

          gap: '12px',
        }}
      >
        <Typography
          sx={{
            color: theme.palette.custom.warning2,
            fontSize: '18px',
            fontWeight: 600,
            width: '100%',
            textAlign: 'center',
          }}
        >
          Package Images validation failed!
        </Typography>
        <Box>
          <Typography sx={{ fontSize: '14px' }}>Traicy rejection reason:</Typography>
          <Typography sx={{ fontSize: '14px', fontStyle: 'italic', fontWeight: 600 }}>
            {traicyRejectReason}
          </Typography>
        </Box>

        <Typography sx={{ fontSize: '14px' }}>You can go back and review your images</Typography>
        <Box sx={{ width: '100%', textAlign: 'center', pt: '10px' }}>
          <Button onClick={handleClose} variant="contained" size="small">
            Go back
          </Button>
        </Box>
      </Box>
    </ModalWrapper>
  )
}
